<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加用户"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="radio-group-box">
      <el-radio-group v-model="tabName" style="margin-bottom: 30px;">
        <el-radio-button label="peopleInfo">人员信息</el-radio-button>
        <el-radio-button label="liftInfo">电梯信息</el-radio-button>
      </el-radio-group>
    </div>
    <div>
      <div v-show="tabName === 'peopleInfo'">
        <div class="dialog__container">
          <el-form
            inline
            ref="form"
            class="search-form"
            label-position="right"
            :model="form"
            :rules="rules"
            label-width="70px"
          >
            <el-form-item label="所属单位：" prop="unitId">
              <el-select
                size="mini"
                v-model="form.unitId"
                filterable
                placeholder="请选择所属单位"
                clearable
                reserve-keyword
                :remote="true"
                disabled
                @change="chooseUnit"
                :remote-method="searchUnitList"
                @visible-change="searchUnitList('')"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.id"
                  :label="item.unitName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属部门：" prop="departmentId" class="mr0">
              <el-select
                size="mini"
                v-model="form.departmentId"
                filterable
                placeholder="请选择所属部门"
                clearable
                reserve-keyword
                :remote="true"
                :remote-method="searchDepartmentList"
                @visible-change="searchDepartmentList('')"
                @change="chooseDepartment"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.departmentName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="登陆账号：" prop="phone">
              <el-input size="mini" v-model.trim="form.phone" placeholder="请输入手机号或登陆号" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="密码：" class="mr0" prop="password">
              <el-input size="mini" v-model.trim="form.password" placeholder="请输入密码" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="姓名：" prop="nickname" class="mr0">
              <el-input size="mini" v-model.trim="form.nickname" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="idCode">
              <el-input size="mini" v-model.trim="form.idCode" placeholder="请输入身份证号" clearable></el-input>
            </el-form-item>
            <el-form-item label="性别：" class="mr0">
              <el-select size="mini" v-model="form.sex" value-key="dictionaryCode">
                <el-option
                  v-for="item in xbDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                  placeholder="请选择性别"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否部门管理：" label-width="98px" class="label-with-six-word mr0">
              <el-select size="mini" v-model="form.departmentManage" value-key="dictionaryCode">
                <el-option
                  v-for="item in departmentManageArray"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="授权应用：" class="checkbox-group-box mr0">
              <el-checkbox-group v-model="checkAppTypeList">
                <el-checkbox
                  @change="changeAppTypeCheck(item)"
                  v-for="item in appTypeList"
                  :key="item.typeCode"
                  :label="item.typeCode"
                >{{item.typeName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="授权角色：" class="checkbox-group-box mr0">
              <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane
                  :label="item.appName"
                  :name="item.appCode"
                  v-for="item in roleSimpleList"
                  :key="item.appCode"
                >
                  <el-checkbox-group v-model="checkRoleList">
                    <el-checkbox
                      @change="changeRoleCheck"
                      v-for="it in item.roleList"
                      :key="it.roleCode + item.appCode"
                      :label="it.id + ',' + item.appCode"
                    >{{it.roleName}}</el-checkbox>
                  </el-checkbox-group>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div v-show="tabName === 'liftInfo'">
        <select-lift
          ref="selectLift"
          :unitId="form.unitId"
          :departmentId="form.departmentId"
          :projectList="treeData"
          @lifts="setLifts"
        ></select-lift>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import PeopleInfo from "./PeopleInfo";
import SelectLift from "./LiftInfo";
import {
  getProjectLiftTree,
  getAppTypeList,
  getRoleSimpleList,
  getUnitSimpleList,
  getDepartmentSimpleList,
  saveUser,
  getUnitInfoByUser
} from "@/api/UserManagement";
import { mapState } from "vuex";
const addResource = function () {};
const getResourceTypeList = function () {};
export default {
  data() {
    return {
      tabName: "peopleInfo",
      name: "",
      departmentManageArray: [
        { dictionaryValue: "是", dictionaryCode: 1 },
        { dictionaryValue: "否", dictionaryCode: 0 },
      ],
      form: {
        unitId: "",
        departmentId: "",
        nickname: "",
        idCode:"",
        password: "",
        sex: "",
        phone: "",
        departmentManage: 1,
        liftIdList: [],
        applicationRoleList: [],
      },
      rules: {
        unitId: [
          {
            required: true,
            message: "请选择所属单位",
            trigger: "change",
          },
        ],
        departmentId: [
          {
            required: true,
            message: "请选择所属部门",
            trigger: "change",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号或登陆账号",
            trigger: "blur",
          },
        ],
        nickname: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        dorder: [
          {
            required: true,
            message: "请输入排序号",
            trigger: "blur",
          },
        ],
      },
      resourceTypeList: [],
      checkAppTypeList: [],
      activeName: "YHGHT",
      appTypeList: [],
      unitList: [],
      departmentList: [],
      appTypeCodeList: [],
      roleSimpleList: [],
      defaultProps: {
        children: "liftList",
        label: "liftName",
      },
      treeData: [],
      checkRoleList: [],
    };
  },
  computed: {
    ...mapState("common/dictionary", ["xbDicts"]),
  },
  components: {
    PeopleInfo,
    SelectLift,
  },
  created() {
    this.searchUnitList()
    this.getUnitInfoByUser()
  },
  methods: {
    async getUnitInfoByUser() {
      const res = await getUnitInfoByUser();
      if (res.code === 200) {
        this.form.unitId = res.data.unitId
        this.getAppTypeList();
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const params = { ...this.form }
          params.sex = params.sex * 1
          const res = await saveUser(params);
          if (res.code === 200) {
            this.$message.success("添加成功");
            this.$emit("confirm");
          }
        }
      });
    },
    async searchUnitList(keyword) {
      const res = await getUnitSimpleList({
        keyword: keyword,
        size: 100,
      });
      if (res.code === 200) {
        this.unitList = res.data;
      }
    },
    async searchDepartmentList(keyword) {
      if (!this.form.unitId) {
        this.departmentList = [];
        return;
      }
      const res = await getDepartmentSimpleList({
        keyword: keyword,
        size: 100,
        unitId: this.form.unitId,
      });
      if (res.code === 200) {
        this.departmentList = res.data;
      }
    },
    async getRoleSimpleList() {
      const res = await getRoleSimpleList({
        appCodeList: this.appTypeCodeList,
      });
      if (res.code === 200) {
        this.roleSimpleList = res.data;
      }
    },
    async getAppTypeList() {
      const res = await getAppTypeList({ unitId: this.form.unitId });
      if (res.code === 200) {
        this.appTypeList = res.data;
      }
    },
    async getResourceTypeList() {
      const res = await getResourceTypeList();
      if (res.code === 200) {
        this.resourceTypeList = res.data;
      }
    },
    chooseResourceType(value) {
      if (value == 3 || value == 4) {
        this.form.menuShow = 0;
      } else {
        this.form.menuShow = 1;
      }
    },
    handleClick(tab) {},
    changeAppTypeCheck(item) {
      this.appTypeCodeList = this.checkAppTypeList;
      this.getRoleSimpleList();
      this.setApplicationRoleList()
      this.activeName = this.appTypeCodeList[0]
    },
    chooseDepartment(val) {
      if (val) {
        this.getProjectLiftTree();
      }
    },
    chooseUnit(val) {
      this.departmentList = [];
      this.form.departmentId = null;
      if (val) {
        this.getAppTypeList();
        this.getProjectLiftTree();
      }
    },
    async getProjectLiftTree() {
      if (this.form.unitId && this.form.departmentId) {
        const res = await getProjectLiftTree({
          unitId: this.form.unitId,
          departmentId: this.form.departmentId,
        });
        if (res.code === 200) {
          this.treeData = res.data;
        }
      }
    },
    checkNodes(checkedNodes, checkedKeys) {
      console.log(checkedKeys);
    },
    getLiftId() {},
    changeRoleCheck() {
      this.setApplicationRoleList()
    },
    setApplicationRoleList() {
      if (this.checkRoleList && this.checkRoleList.length) {
        let arr = [];
        this.checkRoleList.forEach((item) => {
          if (arr.indexOf(item.split(",")[1]) < 0) {
            if (this.appTypeCodeList.indexOf(item.split(",")[1])>=0) {
              arr.push(item.split(",")[1]);
            }

          }
        });
        this.form.applicationRoleList = [];
        arr.forEach((item) => {
          let obj = {
            roleIdList: [],
            selectedAppCode: item,
          };
          this.checkRoleList.forEach((it) => {
            if (it.split(",")[1] == item) {
              obj.roleIdList.push(it.split(",")[0] * 1);
            }
          });
          this.form.applicationRoleList.push(obj);
        });
      }
    },
    setLifts(lifts, project) {
      this.form.liftIdList = lifts;
    },
  },
};
</script>

<style lang="scss">
.liftInfo {
  .liftInfo-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/UserManagement/components/AddUser.vue